function supportsObjectFit () {
    const testElem = document.createElement('div').style;
    if ('object-fit' in testElem || '-o-object-fit' in testElem) {
        return true;
    }
    return false;
}

if (!supportsObjectFit()) {
    const images = document.getElementsByClassName('object-fit-cover');
    const imagesLen = images.length;
    let curImg;
    let curImgSrc;
    let shimWrapper;
    let shimImg;
    let i = 0;

    for (i; i < imagesLen; i++) {
        curImg = images[i];
        if ('currentSrc' in curImg) {
            curImgSrc = curImg.currentSrc;
            if (curImgSrc === '') {
                curImgSrc = curImg.src;
            }
        } else {
            curImgSrc = curImg.src;
        }
        shimWrapper = document.createElement('div');
        shimImg = document.createElement('img');
        shimWrapper.className = curImg.className;
        shimWrapper.style.backgroundImage = 'url(' + curImgSrc + ')';
        shimImg.src = curImgSrc;
        shimWrapper.appendChild(shimImg);
        curImg.parentNode.replaceChild(shimWrapper, curImg);
    }
}
